(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerWrapper = document.querySelector('.header-wrapper');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBackgroundColorScheme = this.getAttribute('data-background-color-scheme');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      //this.throttledScrollHandler = throttle(this.onScrollHandler, 300);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      if (this.header) {
        observer.observe(this.header);
      }
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
        this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-always-sticky');
        this.header.style.transform = 'translateY(-100%)';
      }

      if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 2) {
        this.header.classList.remove('color-background-2');
        this.header.style.transition = 'background var(--duration-short)';
        this.header.style.transform = 'translateY(0)';
      }

      if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
        this.header.classList.remove('shopify-section-header-sticky');
        this.header.style.transform = 'translateY(0)';
        this.header.style.transition = 'background var(--duration-short)';
        if (this.header.classList.contains(this.headerBackgroundColorScheme)) {
          this.header.classList.add('color-background-2');
        }
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      if (document.querySelector('.overflow-hidden-tablet')) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      if (document.querySelector('.entering-section')) {
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
      } else {
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden', 'color-background-2');
      }
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      if (this.header.classList.contains(this.headerBackgroundColorScheme)) {
        this.header.classList.add('color-background-2');
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      if (this.disclosures) {
        this.disclosures.forEach((disclosure) => {
          disclosure.close();
        });
      }
      this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
      if (this.disclosureLists) {
        this.disclosureLists.forEach((disclosureList) => {
          disclosureList.setAttribute('hidden', true);
        });
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jo-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bars = document.querySelectorAll('.jo-announce[data-jo-rotate="true"]');
    if (!bars.length) return;

    bars.forEach(function (bar) {
      var items = bar.querySelectorAll('[data-jo-announce-item]');
      if (items.length < 2) return;

      // Only rotate at mobile widths — desktop shows everything inline
      function isMobile() { return window.matchMedia('(max-width: 700px)').matches; }

      var idx = 0;
      function setActive(i) {
        items.forEach(function (el, j) {
          el.classList.toggle('is-active', i === j);
        });
      }

      function tick() {
        if (!isMobile()) {
          items.forEach(function (el) { el.classList.remove('is-active'); });
          return;
        }
        idx = (idx + 1) % items.length;
        setActive(idx);
      }

      setActive(0);
      setInterval(tick, 4000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jo-best-sellers"] && !Shopify.designMode) return;
  try {
    
  /* Quick-add handler — posts to /cart/add.js.
     Dispatches a 'jo:cart:updated' event afterward so the theme's
     existing cart drawer can listen and refresh. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-jo-quick-add]');
    if (!btn) return;
    e.preventDefault();

    var id = btn.getAttribute('data-variant-id');
    if (!id) return;

    var original = btn.textContent;
    btn.textContent = 'Adding…';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      btn.textContent = 'Added ✓';
      document.dispatchEvent(new CustomEvent('jo:cart:updated'));
      setTimeout(function () {
        btn.textContent = original;
        btn.disabled = false;
      }, 1800);
    })
    .catch(function () {
      btn.textContent = 'Try again';
      btn.disabled = false;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jo-main-product"] && !Shopify.designMode) return;
  try {
    
  /* ================================================================
     Product page interactions
     - Gallery thumbnail swap
     - Qty stepper
     - Size option selection (updates hidden variant_id + ATC text)
     - Stock status updates on variant change
     ================================================================ */
  (function () {
    // Use the outermost wrapper so multiple instances on a page are safe
    var roots = document.querySelectorAll('.jo-p');
    roots.forEach(function (root) {
      /* ---------------- Gallery ---------------- */
      var thumbs = root.querySelectorAll('[data-jo-thumb]');
      var slides = root.querySelectorAll('[data-jo-slide]');
      thumbs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var idx = btn.getAttribute('data-jo-thumb');
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          slides.forEach(function (s) { s.classList.remove('is-active'); });
          btn.classList.add('is-active');
          var target = root.querySelector('[data-jo-slide="' + idx + '"]');
          if (target) target.classList.add('is-active');
        });
      });

      /* ---------------- Thumbnail carousel arrows ----------------
         Shows arrows only when scroll is possible in that direction.
         Recalculates on scroll, resize, and load (handles lazy images
         that expand the track width after paint). */
      var track = root.querySelector('[data-jo-gallery-thumbs]');
      var prev = root.querySelector('[data-jo-carousel-prev]');
      var next = root.querySelector('[data-jo-carousel-next]');

      if (track && prev && next) {
        function updateArrows() {
          // 1px tolerance absorbs fractional scroll positions from
          // sub-pixel layout — prevents arrows flickering on and off
          var canPrev = track.scrollLeft > 1;
          var canNext = track.scrollLeft + track.clientWidth < track.scrollWidth - 1;
          prev.classList.toggle('is-visible', canPrev);
          next.classList.toggle('is-visible', canNext);
        }

        function scrollByTile(direction) {
          var firstThumb = track.querySelector('.jo-p__gallery-thumb');
          if (!firstThumb) return;
          // Scroll by one tile-width + the gap
          var tileWidth = firstThumb.offsetWidth + 12;
          track.scrollBy({ left: tileWidth * direction, behavior: 'smooth' });
        }

        prev.addEventListener('click', function () { scrollByTile(-1); });
        next.addEventListener('click', function () { scrollByTile(1); });
        track.addEventListener('scroll', updateArrows, { passive: true });
        window.addEventListener('resize', updateArrows);

        // Initial check + recheck after images load (lazy-loaded
        // thumbnails can change scrollWidth once they're decoded)
        updateArrows();
        track.querySelectorAll('img').forEach(function (img) {
          if (img.complete) return;
          img.addEventListener('load', updateArrows, { once: true });
        });
      }

      /* ---------------- Qty stepper ---------------- */
      var qtyInput = root.querySelector('[data-jo-qty-input]');
      var qtyBtns = root.querySelectorAll('[data-jo-qty]');
      qtyBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!qtyInput) return;
          var current = parseInt(qtyInput.value, 10) || 1;
          var op = btn.getAttribute('data-jo-qty');
          var next = op === '+' ? current + 1 : Math.max(1, current - 1);
          qtyInput.value = next;
        });
      });

      /* ---------------- Size / variant selection ----------------
         When a size button is clicked we need to:
         1. Mark it as selected in the UI
         2. Find the matching variant by combining the selected
            option value with any other options on the product
         3. Update the hidden input and ATC state accordingly
         ------------------------------------------------------------ */
      var variantInput = root.querySelector('[data-jo-variant-id]');
      var atcBtn = root.querySelector('[data-jo-atc]');
      var atcText = root.querySelector('[data-jo-atc-text]');
      var atcPrice = root.querySelector('[data-jo-atc-price]');
      var stockEl = root.querySelector('[data-jo-stock]');
      var stockText = root.querySelector('[data-jo-stock-text]');
      var productData = null;

      // Fetch product JSON once (Shopify's built-in variant data endpoint)
      var productHandle = window.location.pathname.split('/products/')[1];
      if (productHandle) {
        productHandle = productHandle.split('?')[0].split('/')[0];
        fetch('/products/' + productHandle + '.js')
          .then(function (r) { return r.json(); })
          .then(function (data) { productData = data; })
          .catch(function () { /* silently continue — size buttons just won't update price/stock */ });
      }

      function findVariant(selectedOptions) {
        if (!productData) return null;
        // Shopify variants have option1, option2, option3 — match against selected names
        var optionNames = productData.options || [];
        return productData.variants.find(function (v) {
          return optionNames.every(function (name, i) {
            var selected = selectedOptions[name.toLowerCase()];
            if (!selected) return true; // no selection yet for this option
            return v['option' + (i + 1)] === selected;
          });
        });
      }

      function readSelectedOptions() {
        var opts = {};
        root.querySelectorAll('.jo-p__size-option.is-selected').forEach(function (btn) {
          var name = btn.getAttribute('data-jo-option-name');
          var value = btn.getAttribute('data-jo-option-value');
          if (name) opts[name.toLowerCase()] = value;
        });
        return opts;
      }

      function formatMoney(cents) {
        // ZAR: "R 1,600" style. Shopify cents → rands.
        var rands = cents / 100;
        // en-ZA uses 'R' prefix with space — match the live site format
        return 'R ' + rands.toLocaleString('en-ZA', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
      }

      function updateVariantUI(variant) {
        if (!variantInput) return;
        if (variant) {
          variantInput.value = variant.id;
          if (atcBtn) atcBtn.disabled = !variant.available;
          if (atcText) atcText.textContent = variant.available ? 'Add to cart' : 'Sold out';
          if (atcPrice && variant.available) atcPrice.textContent = '· ' + formatMoney(variant.price);
          else if (atcPrice) atcPrice.textContent = '';

          // Stock status
          if (stockEl && stockText) {
            stockEl.classList.remove('jo-p__stock--low', 'jo-p__stock--oos');
            if (!variant.available) {
              stockEl.classList.add('jo-p__stock--oos');
              stockText.textContent = 'Out of stock · Request a restock notification';
            } else if (variant.inventory_quantity > 0 && variant.inventory_quantity <= 5) {
              stockEl.classList.add('jo-p__stock--low');
              stockText.textContent = 'Only ' + variant.inventory_quantity + ' left · Ships in 2–3 days';
            } else {
              stockText.textContent = 'In stock · Ships in 2–3 days';
            }
          }

          // Update URL silently so copy-link carries the variant
          if (window.history && window.history.replaceState) {
            var url = new URL(window.location);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url);
          }
        } else {
          if (atcBtn) atcBtn.disabled = true;
          if (atcText) atcText.textContent = 'Unavailable';
        }
      }

      var sizeOptions = root.querySelectorAll('.jo-p__size-option');
      sizeOptions.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var optionName = btn.getAttribute('data-jo-option-name');
          // Deselect siblings within the same option group
          btn.parentElement.querySelectorAll('.jo-p__size-option').forEach(function (sib) {
            sib.classList.remove('is-selected');
          });
          btn.classList.add('is-selected');

          // Find the matching variant based on all selected options
          var selected = readSelectedOptions();
          var variant = findVariant(selected);
          updateVariantUI(variant);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jo-press-bar"] && !Shopify.designMode) return;
  try {
    
  /* Press bar marquee.
     Self-initialises per-section so multiple press bars on one
     page wouldn't conflict. Speed is in pixels per second; a
     shared RAF loop translates the track leftward and resets to
     0 when the first logo-set has fully scrolled off.
     Pauses on hover/focus; stops entirely under prefers-reduced-motion. */
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;

    document.querySelectorAll('[data-jo-press]').forEach(function (section) {
      var track = section.querySelector('[data-jo-press-track]');
      if (!track) return;

      // Pixels per second — higher = faster scroll
      var speed = parseFloat(section.getAttribute('data-speed')) || 40;

      // The loop distance is exactly half the track's scrollWidth,
      // because the track renders the logo set twice. When we've
      // translated by that distance the second set is now in the
      // position the first occupied — visually identical, safe to
      // reset. We read scrollWidth after a tick so layout settles.
      var loopDistance = 0;
      var position = 0;
      var lastTime = null;
      var paused = false;

      function measure() {
        loopDistance = track.scrollWidth / 2;
      }

      function tick(now) {
        if (lastTime === null) lastTime = now;
        var dt = (now - lastTime) / 1000;
        lastTime = now;

        if (!paused && loopDistance > 0) {
          position -= speed * dt;
          // When we've scrolled past the first set, wrap position
          // back to 0. Modulo-style so overshoot isn't lost.
          if (position <= -loopDistance) {
            position += loopDistance;
          }
          track.style.transform = 'translateX(' + position + 'px)';
        }
        requestAnimationFrame(tick);
      }

      // Pause on hover (mouse)
      section.addEventListener('mouseenter', function () { paused = true; });
      section.addEventListener('mouseleave', function () { paused = false; });

      // Pause on focus (keyboard users tabbing through any linked logo)
      section.addEventListener('focusin', function () { paused = true; });
      section.addEventListener('focusout', function () { paused = false; });

      // Re-measure when images load — their intrinsic width only resolves
      // after decode, which affects the track's scrollWidth. Without this
      // the loop distance might be computed before images have sized.
      track.querySelectorAll('img').forEach(function (img) {
        if (img.complete) return;
        img.addEventListener('load', measure, { once: true });
      });

      // Re-measure on window resize — logo sizes change at breakpoints.
      window.addEventListener('resize', measure);

      measure();
      requestAnimationFrame(tick);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  //class CartNote extends HTMLElement {
  //  constructor() {
  //    super();

  //    this.addEventListener(
  //      'change',
  //      debounce((event) => {
  //        const body = JSON.stringify({ note: event.target.value });
  //        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
  //      }, 300)
  //    );
  //  }
  //}

  //customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();

      this.isProductPage = true;
      this.visibleMediaObserver = null;
      this.visibleMediaRatios = new Map();
      this.activeVisibleMedia = null;
    }

    hide() {
      this.teardownVisibleMediaAutoplay();
      super.hide(this.isProductPage);
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
      this.setupVisibleMediaAutoplay();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      if (activeMedia) {
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();
      }
      if (
        activeMedia?.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia?.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }

    isVideoAutoplayEnabled() {
      return this.dataset.enableVideoAutoplay === 'true';
    }

    setupVisibleMediaAutoplay() {
      this.teardownVisibleMediaAutoplay();

      if (!this.isVideoAutoplayEnabled()) return;

      const dialog = this.querySelector('.product-media-modal__dialog');
      const mediaItems = Array.from(this.querySelectorAll('.product-media-modal__item')).filter((item) =>
        item.querySelector('deferred-media')
      );

      if (!dialog || !mediaItems.length) return;

      this.visibleMediaObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.visibleMediaRatios.set(entry.target, entry.isIntersecting ? entry.intersectionRatio : 0);
          });

          this.syncVisibleMediaPlayback();
        },
        {
          root: dialog,
          threshold: [0, 0.35, 0.6, 0.85],
        }
      );

      mediaItems.forEach((item) => {
        this.visibleMediaRatios.set(item, 0);
        this.visibleMediaObserver.observe(item);
      });

      requestAnimationFrame(() => this.syncVisibleMediaPlayback());
    }

    syncVisibleMediaPlayback() {
      if (!this.isVideoAutoplayEnabled()) return;

      let nextActiveMedia = null;
      let maxRatio = 0;

      this.visibleMediaRatios.forEach((ratio, item) => {
        if (ratio > maxRatio) {
          maxRatio = ratio;
          nextActiveMedia = item;
        }
      });

      if (maxRatio < 0.35) {
        nextActiveMedia = null;
      }

      if (this.activeVisibleMedia === nextActiveMedia) return;

      window.pauseAllMedia();
      this.activeVisibleMedia = nextActiveMedia;

      if (!nextActiveMedia) return;

      const deferredMedia = nextActiveMedia.querySelector('deferred-media');
      if (deferredMedia) {
        window.playMedia(deferredMedia);
      }
    }

    teardownVisibleMediaAutoplay() {
      this.visibleMediaObserver?.disconnect();
      this.visibleMediaObserver = null;
      this.visibleMediaRatios.clear();
      this.activeVisibleMedia = null;
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
